(function () {
  function initPlatesGroup(root) {
    const select = root.querySelector('[data-product-addons-plates-select]');
    const otherWrap = root.querySelector('[data-product-addons-plates-other-wrap]');
    const otherInput = root.querySelector('[data-product-addons-plates-other]');
    const hidden = root.querySelector('[data-product-addons-plates-hidden]');

    if (!select || !hidden) return;

    select.addEventListener('change', function () {
      const isOther = select.value === 'other';
      if (otherWrap) {
        otherWrap.style.display = isOther ? '' : 'none';
      }
      if (otherInput && !isOther) {
        otherInput.value = '';
      }
      syncPlatesHidden(select, otherInput, hidden);
    });

    if (otherInput) {
      otherInput.addEventListener('input', function () {
        syncPlatesHidden(select, otherInput, hidden);
      });
    }
  }

  function syncPlatesHidden(select, otherInput, hidden) {
    const val = select.value;
    if (!val) {
      hidden.value = '';
      hidden.disabled = true;
      return;
    }
    if (val === 'other') {
      hidden.value = (otherInput && otherInput.value.trim()) || '';
    } else {
      hidden.value = val;
    }
    hidden.disabled = hidden.value === '';
  }

  function prepareFormForSubmit(form) {
    const cardFields = form.querySelectorAll('.product-addons__card-message');
    cardFields.forEach((field) => {
      if (!field.value || !field.value.trim()) {
        field.disabled = true;
      }
    });

    form.querySelectorAll('[data-product-addons-plates]').forEach((group) => {
      const select = group.querySelector('[data-product-addons-plates-select]');
      const otherInput = group.querySelector('[data-product-addons-plates-other]');
      const hidden = group.querySelector('[data-product-addons-plates-hidden]');
      if (select && hidden) {
        syncPlatesHidden(select, otherInput, hidden);
      }
    });
  }

  function initProductAddons() {
    document.querySelectorAll('[data-product-addons-plates]').forEach(initPlatesGroup);

    document.querySelectorAll('product-form form[data-type="add-to-cart-form"]').forEach((form) => {
      if (form.dataset.productAddonsBound === 'true') return;
      form.dataset.productAddonsBound = 'true';
      form.addEventListener(
        'submit',
        function () {
          prepareFormForSubmit(form);
        },
        true
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAddons);
  } else {
    initProductAddons();
  }

  document.addEventListener('shopify:section:load', initProductAddons);
})();
